import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {LightButton} from '../../styles/components/button.style';
import {fadeLoop} from '../../styles/keyframes/keyframes';
import {isIE11} from '../../helpers/ie.helper';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  background: none;
`;

export const Background = styled.img`
  background: ${p => `url(${p.backgroundImages.desktop}) no-repeat center center fixed`};
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  flex-grow: 1;
  max-height: 100vh;
  ${media.small`
    background-attachment: initial;
  `};
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  min-height: 100vh;
  opacity: 0.8;
  z-index: 1;
`;

export const PanelContent = styled.div`
  z-index: 2;
  width: 100%;
  min-height: 100vh;
  padding: ${p => p.theme.padding};
  color: ${p => p.theme.primaryColor};
  background: ${p => `linear-gradient(to left, ${p.firstColor}, ${p.secondColor})`};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  ${isIE11() && `
    min-height: 100vh;
    height: 99.99vh;
  `}
`;

export const Logo = styled.img`
  margin-top: 4rem;
  max-width: 100%;
  max-height: 15rem;
  height: 15rem;
  ${media.medium`
      margin-top: 10rem;
  `};
  ${media.small`
      margin-top: 2rem;
  `};
`;

export const H1 = styled.h1`
  display: flex;
  justify-content: center;
  padding: 0 2.4rem;
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
  max-width: 70%;
  white-space: pre-line;
  font-size: ${p => p.theme.h1.large.fontSize};
  line-height: ${p => p.theme.h1.large.lineHeight};
  ${media.medium`
    font-size: ${p => p.theme.h1.medium.fontSize};
    line-height: ${p => p.theme.h1.medium.lineHeight};
  `};
  ${media.small`
    font-size: ${p => p.theme.h1.small.fontSize};
    line-height: ${p => p.theme.h1.small.lineHeight};
    padding: 0;
  `};
`;

export const HomeBody = styled.div`
  font-size: 1.8rem;
  max-width: 60%;
  margin-top: 2.4rem;
  ${media.small`
    max-width: 80%;
  `};
`;

export const OrderNow = LightButton.extend`
   margin-top: 2rem;
   max-height: 5rem;
   margin-bottom: 2rem;
`;

export const Arrow = styled.img`
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  color: ${p => p.theme.primaryColor};
  height: 4rem;
  width: 4rem;
  z-index: 99;
  cursor: pointer;
  transform: rotate(90deg);
  opacity: 0.8;
  animation: ${fadeLoop} 2s infinite;
`;

export const StyledSpecialOffer = styled.div`
  margin-top: 2.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  div, p, span, h1, h2, h3 {
    color: ${p => p.black ? '#000' : p.theme.primaryColor};
    max-width: ${props => props.theme.container.wider.width};
  }

  ${isIE11() && `
    width: 100%;
  `}
`;

export const OfferContent = styled.div`
  background-color: ${p => p.black ? p.theme.primaryColor : 'transparent'};
  padding-top: ${p => p.black ? '4rem' : 0};
  margin-top: ${p => isIE11() && p.black ? '-8.5rem' : 0};
  ${isIE11() && `
    width: 100%;
  `}
`;

export const OfferIcon = styled.div`
  width: ${p => p.black ? '8.5rem' : '6rem'};
  height: ${p => p.black ? '8.5rem' : '6rem'};
  min-height: ${p => p.black ? '8.5rem' : '6rem'};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => p.black ? '#000' : p.theme.primaryColor};
  position: ${p => p.black ? 'absolute' : 'relative'};
  top: ${p => p.black ? '-5rem' : 0};
  ${isIE11() && `
    position: relative;
  `}
`;

export const OfferTitle = styled.div`
  font-size: 2rem;
  margin-top: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-weight: bold;
`;

export const Star = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  fill: ${p => p.black ? '#000' : p.theme.primaryColor};
  svg {
    margin-top: 0.5rem;
    width: ${p => p.black ? '2.6rem' : '3.4rem'};
    height: ${p => p.black ? '2.6rem' : '3.4rem'};
  }
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/LandingPanel.style.js